import { render, staticRenderFns } from "./person-greeting-card.vue?vue&type=template&id=c11dcf9e"
import script from "./person-greeting-card.vue?vue&type=script&lang=js"
export * from "./person-greeting-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports